import PaymentAccountForm from "../../components/AccountComponents/BankAccountForm";

function NewPaymentAccountPage(){
    return(<PaymentAccountForm method="post"  title="Bank"/>)
}


export default NewPaymentAccountPage;